module.exports = __webpack_public_path__ + "img/search-left-white.2a3d7560.svg";